import React from 'react';
import PropTypes from 'prop-types';
import { WithContext as ReactTags } from 'react-tag-input';
import { withStyles } from '@material-ui/core/styles';
import { primary1000, secondary0 } from '../../themes/colors';

const styles = () => ({
  tagInputField: {
    width: '100%',
    minHeight: '3rem',
    padding: '0.375rem 0.75rem',
    borderRadius: '0.25rem',
    border: '1px solid #CED4DA',
    '&:hover': {
      border: `1px solid ${primary1000}`,
    },
    '&:focus': {
      outline: 'none',
      border: `1px solid ${primary1000}`,
    },
  },
  tag: {
    display: 'inline-block',
    backgroundColor: `${primary1000}`,
    fontSize: '0.875rem',
    fontWeight: '600',
    borderRadius: '0.375rem',
    color: `${secondary0}`,
    margin: '0 0.375rem 0.375rem 0',
    padding: '0 0 0.375rem 0.375rem',
  },
  remove: {
    position: 'relative',
    top: '2px',
    display: 'inline-block',
    textAlign: 'center',
    textDecoration: 'none',
    padding: '0',
    border: 'none',
    font: 'inherit',
    color: 'inherit',
    backgroundColor: 'transparent',
    width: '0.875rem',
    height: '0.875rem',
    cursor: 'pointer',
    fontSize: '1.25rem',
    margin: '0 0.25rem',
  },
});

const RenderReactTags = ({
  classes, handleAddition, tags, handleDelete, placeholder, labelField, handleInputBlur,
}) => (
  <ReactTags
    classNames={{
        tagInputField: classes.tagInputField,
        tag: classes.tag,
        remove: classes.remove,
      }}
    allowDeleteFromEmptyInput={false}
    autofocus={false}
    allowDragDrop={false}
    handleAddition={handleAddition}
    tags={tags}
    handleDelete={handleDelete}
    placeholder={placeholder}
    labelField={labelField}
    handleInputBlur={handleInputBlur}
  />
);


RenderReactTags.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  handleAddition: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleInputBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  labelField: PropTypes.string.isRequired,
  tags: PropTypes.shape({}).isRequired,
};


export default withStyles(styles, { withTheme: true })(RenderReactTags);
